var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortDesc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 17,
    viewBox: "0 0 9 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.67911 12.8733L4.15244 15.3467C4.1991 15.3933 4.2591 15.4333 4.32577 15.46C4.33244 15.46 4.3391 15.46 4.34577 15.4667C4.3991 15.4867 4.45244 15.5 4.51244 15.5C4.64577 15.5 4.77244 15.4467 4.86577 15.3533L7.35244 12.8733C7.54577 12.68 7.54577 12.36 7.35244 12.1667C7.1591 11.9733 6.8391 11.9733 6.64577 12.1667L5.01244 13.8L5.01244 3C5.01244 2.72667 4.78577 2.5 4.51244 2.5C4.2391 2.5 4.01244 2.72667 4.01244 3L4.01244 13.7933L2.38577 12.1667C2.28578 12.0667 2.15911 12.02 2.03244 12.02C1.90578 12.02 1.77911 12.0667 1.67911 12.1667C1.48578 12.36 1.48578 12.6733 1.67911 12.8733Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDesc);
export default __webpack_public_path__ + "static/media/sort-desc.aa8351d7bbc10d0bfc5f5b002871fa0f.svg";
export { ForwardRef as ReactComponent };